const nickelData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133791/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_b1ffd9e7-5d08-4002-8893-7446afcfa6d9_legksx.png',
  priceAssessmentsBrochureFile: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Nickel-Price-Assessment-Methodology.pdf',
    EnvKey: 'nickelPriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureNickelFilePdfID',
    file_name: 'Nickel Forecast Brochure.pdf',
    category: 'public-documents',
  },
  esgBrochureFile: {
    EnvKey: 'ESGBrochureNickelFilePdfId',
    file_name: 'Nickel Sustainability Brochure.pdf',
    category: 'nickel-esg-brochure',
  },
  banner: {
    title:
      'Our service includes a deep-dive on each link in the nickel supply chain including:',
    descriptions: [
      {
        items: [
          '<strong>Refinery by refinery:</strong> Nickel intermediates and primary products',
          '<strong>Plant by Plant:</strong> Nickel sulphate',
          '<strong>Battery Focus:</strong> Demand by Cathode Chemistry with market share & intensity numbers',
          '<strong>Battery Demand:</strong> Scenarios of EV, Stationary and Portable Tech',
          '<strong>Industrial vs Battery:</strong> market-specific consumption data',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416656/assets/market/nickel/nickel-1_ge67qk.jpg?_i=AA',
        alt: 'Nickel Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416655/assets/market/nickel/nickel-2_nklewv.jpg?_i=AA',
        alt: 'Nickel Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416657/assets/market/nickel/nickel-3_rnhrr5.jpg?_i=AA',
        alt: 'Nickel Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1719416655/assets/market/nickel/nickel-4_iphm1n.jpg?_i=AA',
      title:
        'Review how battery costs vary between technologies, manufacturing scale, and raw material inputs:',
      descriptions: [
        {
          subtitle:
            'Our full-picture understanding of the nickel supply chain into batteries provides the foundation for our cost curve analysis.',
          items: [
            '<strong>Time Travel:</strong> Track changes in the battery-grade cost curve through the forecast period',
            '<strong>Plan for your future contracts</strong>, inventory or investment needs',
          ],
        },
        {
          subtitle:
            'We present the prevailing cost structure for different types of projects, focussing on the feedstock, processing and capex requirements for each supplier to serve the cathode market.',
          items: [
            '<strong>Cost breakdown:</strong> analysis of the cost structure for battery cells across different chemistries',
            '<strong>Bill of materials:</strong> monitor the impact of material costs',
            '<strong>A fully customisable</strong> battery cost model profiling costs across different plants, regions and technology profiles',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1719416656/assets/market/nickel/nickel-5_pdxlp4.jpg?_i=AA',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark Nickel Forecast service:',
      descriptions: [
        {
          items: [
            '<strong>Online</strong> accessible downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in 3 Excel Files – Nickel Forecast, Nickel Price Forecast & Nickel Cost Model',
            '<strong>Implement Ideas:</strong> Each file is fully customisable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}
export default nickelData
